import dataLayer from '../dataLayer/reducer';
import { KIJS } from '../config';
import grey from '@material-ui/core/colors/grey';
import {DARKRED, PLASTICGREEN, DARKBLUE, BLUE, LIGHTBLUE, ORANGELIGHT, ORANGEDARK} from '../colors';

export const INTENSITY = 'Autobusu kustības intensitāte';
export const AVG_SPEED = 'Autobusu satiksmes ātrums';
export const FILL = 'Autobusu aizpildījums';

export const SPEEDCOLORMAP = [
    [0, DARKBLUE],
    [25, BLUE],
    [35, LIGHTBLUE],
    [45, ORANGELIGHT],
    [55, ORANGEDARK]
];


const INTENSITY_DEF = 'Sabiedrisko autobusu regulāro reisu skaits 2017.gada ziemas sezonas darbdienas rītos  ar izpildes sākumu no 06:30 līdz 09.00 pēc Autotransporta direkcijas sniegtās informācijas par reģionālās nozīmes reisiem un pieturām. Reģionālās nozīmes reisi neietver tos, kurus pasūta republikas nozīmes pilsētas.';
const AVG_SPEED_DEF = 'Vidējais autobusu satiksmes ātrums 2017.gada ziemas sezonas darbdienas rīta reisos  ar izpildes sākumu no 06:30 līdz 09.00 aprēķināts, ierēķinot stāvēšanu pieturvietās (pasažieru izlaišanu, uzņemšanu, biļešu tirdzniecību, bagāžas novietošanu, garajos reisos arī stāvēšana 10-15 min utt.)';
const FILL_DEF = 'Vidējais pasažieru skaits autobusos 2017.gada ziemas sezonas darbdienas rītos  ar izpildes sākumu no 06:30 līdz 09.00 (aprēķināts pēc pārvadātāju sniegtās informācijas ATD par vidējo pasažieru skaitu visa reisa garumā)';

export const MODULE_KEY = 'mobility';

const ITEM_STYLE = {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] };

const DefaultState = {
    active: [],
    activeData: [],
    id: 1,
    data: [
            {id: 'intensity_traffic', style: ITEM_STYLE,
                textStyle: {color: grey[800]}, name: 'Satiksmes intensitāte', active: false,
                tooltip: true,
                tooltipText: 'Gada vidējais caurbraucošo automašīnu skaits diennaktī pēc VAS”Latvijas Valsts ceļi” datiem',
            },
            {id: 'intensity_traffic_cargo', style: ITEM_STYLE,
                textStyle: {color: grey[800]}, name: 'Kravas satiksmes intensitāte', active: false,
                tooltip: true,
                tooltipText: 'Gada vidējais caurbraucošo kravas automašīnu skaits diennaktī pēc VAS”Latvijas Valsts ceļi” datiem',
            },
            {
                id: 1, 
                name: INTENSITY, 
                active: false, 
                style: ITEM_STYLE,
                textStyle: {color: grey[800]},
                group: 'busIntensity',
                tooltip: true,
                tooltipText: INTENSITY_DEF
            },{
                id: 2, 
                name: AVG_SPEED, 
                active: false, 
                group: 'busIntensity',
                style: ITEM_STYLE,
                textStyle: {color: grey[800]},
                tooltip: true,
                tooltipText: AVG_SPEED_DEF
            },{
                id: 3, 
                name: FILL, 
                style: ITEM_STYLE,
                textStyle: {color: grey[800]},
                active: false, 
                group: 'busIntensity',
                tooltip: true,
                tooltipText: FILL_DEF,
            },{
                id: 'dev_center_atta', 
                style: ITEM_STYLE,
                textStyle: {color: grey[800]},
                name: 'Attīstības centru sasniedzamība', active: false, 
                group: 'devCenterAtta',
                tooltip: true,
                tooltipText: 'Pilsētas nosacītā centra sasniedzamība, braucot ar automašīnu, aprēķināta ar "Karšu izdevniecība Jāņa sēta" izstrādātu programmatūru, tai izvēloties optimālo maršrutu, ņemot vērā ceļu stāvokli, normālos laika apstākļos un attālumu līdz galamērķim. Programmatūras uzstādījumos izmantoti ilgtermiņa novērojumos balstīti vidējie rādītāji. Tā kā ceļu stāvokļa apsekošana netiek veikta katru gadu, atsevišķos posmos programmatūras aprēķinātais sasniedzamības ilgums var atšķirties no reālā',
            },{
                id: 'km3_zones',
                style: ITEM_STYLE,
                textStyle: {color: grey[800]},
                name: 'Autobusa pieturu 3 km sasniedzamība', 
                active: false, 
                group: 'km3Zones',
                tooltip: true,
                tooltipText: 'Ceļu tīkls (ieskaitot kājnieku) 3 km attālumā ap sabiedriskā autotransporta pieturām. Dati autobusa pieturu izvietojumam sagatavoti atbilstoši Autotransporta direkcijas sniegtajai informācijai par starppilsētu autobusu maršrutu pieturām. Karšu izdevniecības Jāņa sēta dati un aprēķini ceļu tīklam',
            }
        ]
}

const PARALEL_LAYERS = ['dev_center_atta', 'km3_zones'];

class dataLayerM extends dataLayer {

    reducerExtender(state, action) {    
        
        switch(action.type) {

            case this.name + "_TOGGLE_BY_IDS":
                var toggle = true;
            case this.name + "_ACTIVATE_BY_IDS":

                var newstate = Object.assign({}, state);

                var activeIDs = action.data;

                if(activeIDs.length > 1) {

                    activeIDs = [activeIDs[activeIDs.length-1]];

                    //PARALEL_LAYERS
                }

                this.recursiveLoop(state.data, (entry) => {

                  if(typeof entry.id !== 'undefined' && activeIDs.indexOf(entry.id) > -1) {

                    if(typeof toggle !== 'undefined') {
                      entry.active = !entry.active;
                    } else {
                      entry.active = !entry.active;
                    }
                    
                  } else {
                    if(typeof toggle === 'undefined' && PARALEL_LAYERS.indexOf(entry.id) === -1) {
                      entry.active = false;
                    }
                    
                  }
                });

              return newstate;
              break;
             case 'schoolMenu_TOGGLE_BY_IDS_SINGLE':

              if(action.data.indexOf("middle_school_model") > -1) {
                 var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                    if(entry.id === 'dev_center_atta') {
                        entry.active = false;
                    }

                });
              }

            case 'population_TOGGLE_BY_IDS_SINGLE':
                var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                    if(entry.id === 'dev_center_atta') {
                        entry.active = false;
                    }
                });
                
                return newstate;
              case 'sportInfrastructure_TOGGLE_BY_IDS_SINGLE':

                var newstate = Object.assign({}, state);

                this.recursiveLoop(newstate.data, (entry)=>{
                    
                        if(entry.id === 'dev_center_atta') {
                        entry.active = false;
                    }
                    
                });

                return newstate;
            break;

           return newstate;
        }
    }
}

var MobilityData = new dataLayerM({
  key: MODULE_KEY,
  defaultState: DefaultState
});

const MobilityExport = MobilityData.export();

export const mobility = MobilityExport[MODULE_KEY];
export default MobilityExport;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mobility/reducer.js